<div class="list-page">
  <h2>Sähköpostipohjat</h2>

  <mat-radio-group (change)="changeSelectedCategory($event?.value)" style="display: block; margin: 4em 0">
    @for (cat of templateCategories; track cat) {
      <mat-radio-button [value]="cat.avain">
        {{ cat.nimi }}
      </mat-radio-button>
    }
  </mat-radio-group>

  <form>
    @if (!lomake.kieli().hidden()) {
      <div>
        <mat-radio-group [formField]="lomake.kieli">
          <mat-radio-button value="fi">Suomi</mat-radio-button>
          <mat-radio-button value="en">Englanti</mat-radio-button>
        </mat-radio-group>
      </div>
    }

    @if (!lomake.yritysmuoto().hidden()) {
      <div>
        <mat-radio-group [formField]="lomake.yritysmuoto">
          @for (ym of yritysmuodot; track ym) {
            <mat-radio-button [value]="ym.avain">
              {{ ym.nimi }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    }

    @if (!lomake.regularOrZen().hidden()) {
      <div>
        <mat-radio-group [formField]="lomake.regularOrZen">
          <mat-radio-button value="reg">Tavallinen</mat-radio-button>
          <mat-radio-button value="zen">Holvi Zen</mat-radio-button>
        </mat-radio-group>
      </div>
    }

    @if (!lomake.hasAttachments().hidden()) {
      <div>
        <mat-radio-group [formField]="lomake.hasAttachments">
          <mat-radio-button [value]="false">Kyllä</mat-radio-button>
          <mat-radio-button [value]="true">Ei</mat-radio-button>
        </mat-radio-group>
      </div>
    }

    @if (!lomake.textStart().hidden()) {
      <div>
        <h3>Tekstin alku</h3>
        <quill-editor [formField]="lomake.textStart"></quill-editor>
        @if (onkoVirhe(lomake.textStart, 'required') && (lomake.textStart().dirty() || lomake.textStart().touched())) {
          <mat-error> Teksti puuttuu </mat-error>
        }
      </div>
    }

    @if (!lomake.alvType().hidden()) {
      <div>
        <mat-radio-group [formField]="lomake.alvType">
          @for (alv of alvTypes; track alv) {
            <mat-radio-button [value]="alv.avain">
              {{ alv.nimi }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    }

    @if (!lomake.textMid().hidden()) {
      <div>
        <h3>Tekstin keskiosa</h3>
        <quill-editor [formField]="lomake.textMid"></quill-editor>
        @if (onkoVirhe(lomake.textMid, 'required') && (lomake.textMid().dirty() || lomake.textMid().touched())) {
          <mat-error> Teksti puuttuu </mat-error>
        }
      </div>
    }

    @if (!lomake.hasSelvitettavia().hidden()) {
      <div>
        <mat-radio-group [formField]="lomake.hasSelvitettavia">
          <mat-radio-button [value]="false">Kyllä</mat-radio-button>
          <mat-radio-button [value]="true">Ei</mat-radio-button>
        </mat-radio-group>
      </div>
    }

    @if (!lomake.textEnd().hidden()) {
      <div>
        <h3>Tekstin loppu</h3>
        <quill-editor [formField]="lomake.textEnd"></quill-editor>
        @if (onkoVirhe(lomake.textEnd, 'required') && (lomake.textEnd().dirty() || lomake.textEnd().touched())) {
          <mat-error> Teksti puuttuu </mat-error>
        }
      </div>
    }

    <!-- <table style="width: 100%;">
    <tr>
      <td style="vertical-align: top;">
        <div style="max-width: 600px; margin: 0 auto;">
          <h2>Suomi</h2>

          <div>
            <strong>Ei ole käytetty:</strong>
            <div *ngFor="let usableVarFi of usableVariablesSuomiObservable | async">{{usableVarFi}}</div>
          </div>
        </div>
      </td>

      <td style="vertical-align: top;">
        <div style="max-width: 600px; margin: 0 auto;">
          <h2>Englanti</h2>
          <quill-editor [formControl]="textEn"></quill-editor>
          <mat-error *ngIf="textEn?.errors?.required && (textEn?.dirty || textEn?.touched)">
            Pohja puuttuu
          </mat-error>
          <div>
            <strong>Have not been used:</strong>
            <div *ngFor="let usableVarEn of usableVariablesEnglishObservable | async">{{usableVarEn}}</div>
          </div>
        </div>
      </td>
    </tr>
  </table>
  <div style="max-width: 600px;">
    <div style="display: flex; justify-content: space-evenly; margin-top: 1em; margin-bottom: 2em;">
      <button class="primarybutton" mat-button (click)="save()" type="button">Tallenna</button>
    </div>
  </div> -->
  </form>
</div>
